const apiRootUrl = window.RUNTIME_CONFIG?.apiRootUrl;

type EndpointKey = keyof typeof defaultEndpoints;

const createEndpoint = (key: EndpointKey, defaultPath: string) => {
    const specificEndpoint = window.RUNTIME_CONFIG?.[key];

    if (typeof specificEndpoint === 'string') {
        return specificEndpoint;
    }

    if (typeof apiRootUrl === 'string') {
        return `${apiRootUrl}${defaultPath}`;
    }

    return defaultEndpoints[key];
};

const defaultEndpoints = {
    manageUrl: 'http://localhost:5000/',
    iotaUrl: 'http://localhost:5001/',
    usersUrl: 'http://localhost:5009/',
    openTelemetryUrl: 'http://localhost:7017/otlp_http',
    datacrafterUrl: 'http://localhost:5058/',
    lspUrl: 'http://localhost:5002/lsp/',
    imageUrl: 'http://localhost:5006/',
    modelTrainingUrl: 'http://localhost:5059/'
} as const;

const configuredEndpoints = {
    manageUrl: createEndpoint('manageUrl', '/manage/'),
    pushUrl: `${createEndpoint('manageUrl', '/manage/').replace(/\/+$/, '')}/hub/`,
    iotaUrl: createEndpoint('iotaUrl', '/iota/'),
    usersUrl: createEndpoint('usersUrl', '/users/'),
    openTelemetryUrl: createEndpoint('openTelemetryUrl', '/otlp_http'),
    datacrafterUrl: createEndpoint('datacrafterUrl', '/datacrafter/'),
    lspUrl: createEndpoint('lspUrl', '/lsp/'),
    imageUrl: createEndpoint('imageUrl', '/image/'),
    modelTrainingUrl: createEndpoint('modelTrainingUrl', '/modeltraining/')
} as const;

export default configuredEndpoints;
